import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEraserTool = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 33 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 20.1183,
			y: 3.64455,
			width: 13.354,
			height: 23.2808,
			rx: 2,
			transform: "rotate(45 20.1183 3.64455)",
			fill: "url(#paint0_linear)"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 11.0722,
			y: 12.6907,
			width: 13.354,
			height: 1.94005,
			transform: "rotate(45 11.0722 12.6907)",
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
			id: "paint0_linear",
			x1: 26.7953,
			y1: 3.64455,
			x2: 26.7953,
			y2: 26.9253,
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ _jsx("stop", { stopColor: "#617ADA" }),
				/* @__PURE__ */ _jsx("stop", {
					offset: .572917,
					stopColor: "#617ADA"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: .625,
					stopColor: "#FF2A2A"
				}),
				/* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#FF2A2A"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgEraserTool);
export { ForwardRef as ReactComponent };
